<template>
  <el-dialog
    title="二维码"
    :visible.sync="visible"
    @close="close"
    width="300px"
  >
    <div style="text-align: center">
      请扫码查看溯源信息
    </div>
    <canvas ref="canvas" class="qrcode" />
  </el-dialog>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QrcodeDialog',
  components: {QRCode},
  data() {
    return {
      visible: false
    }
  },
  methods: {
    open(props = {}) {
      const {value} = props || {}
      if (!value) {
        this.$message.warning('无二维码内容')
        return
      }
      this.visible = true
      this.$nextTick(() => {
        const canvas = this.$refs.canvas
        QRCode.toCanvas(
          canvas,
          value,
          function (error) {
            if (error) console.error(error)
          }
        )
      })
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog__body {
  height: auto;
}
.qrcode {
  height: 260px !important;
  width: 260px !important;
}
</style>
